import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import * as WatchlistActions from './watchlist.actions';
import { WatchlistItem, WatchlistItemIdentity, WatchlistPageContext } from './watchlist.models';
import * as WatchlistSelectors from './watchlist.selectors';

@Injectable()
export class WatchlistFacade {
  loaded$ = this.store.pipe(select(WatchlistSelectors.getWatchlistLoaded));
  allWatchlistItems$ = this.store.pipe(
    select(WatchlistSelectors.getAllWatchlistItems),
    map((items) => items?.sort(this.sortWatchlistItemsByDate))
  );
  allWatchlistItemsCount$ = this.allWatchlistItems$.pipe(map((items) => items.length));

  constructor(private readonly store: Store) {}

  generateWatchlistDocument() {
    this.store.dispatch(WatchlistActions.generateWatchlistDocument());
  }

  addWatchlistItem(watchlistItem: WatchlistItemIdentity, pageContext: WatchlistPageContext) {
    this.store.dispatch(WatchlistActions.addWatchlistItemRequested({ watchlistItem, pageContext }));
  }

  removeWatchlistItem(watchlistItem: WatchlistItemIdentity, pageContext: WatchlistPageContext) {
    this.store.dispatch(WatchlistActions.removeWatchlistItemRequested({ watchlistItem, pageContext }));
  }

  deleteWatchlistItem(watchlistItem: WatchlistItemIdentity, pageContext: WatchlistPageContext) {
    this.store.dispatch(WatchlistActions.deleteWatchlistItemFromList({ watchlistItem, pageContext }));
  }

  shareWatchlistItem(watchlistItem: WatchlistItemIdentity, pageContext: WatchlistPageContext) {
    this.store.dispatch(WatchlistActions.shareWatchlistItemFromList({ watchlistItem, pageContext }));
  }

  shareWatchlistItemAction(network: string, watchlistItem: WatchlistItemIdentity, pageContext: WatchlistPageContext) {
    this.store.dispatch(WatchlistActions.shareActionWatchlistItemFromList({ network, watchlistItem, pageContext }));
  }

  private sortWatchlistItemsByDate(a: WatchlistItem, b: WatchlistItem) {
    // sorting alphabetically should work, since our api exposes all dates in the same timezone
    if (a.created_at > b.created_at) return -1;
    if (a.created_at < b.created_at) return 1;
    return 0;
  }
}
